import * as IntegrationTesting from "./IntegrationTesting/index.js";
/** CoStar.Api.Maps.PointsOfInterest.EntityType */
export var EntityType;
(function (EntityType) {
    EntityType[EntityType["Airport"] = 2] = "Airport";
    EntityType[EntityType["College"] = 3] = "College";
    EntityType[EntityType["MilitaryBase"] = 7] = "MilitaryBase";
    EntityType[EntityType["Park"] = 9] = "Park";
    EntityType[EntityType["Restaurant"] = 11] = "Restaurant";
    EntityType[EntityType["School"] = 13] = "School";
    EntityType[EntityType["ShoppingCenter"] = 14] = "ShoppingCenter";
    EntityType[EntityType["TransitStation"] = 15] = "TransitStation";
    EntityType[EntityType["Seaport"] = 17] = "Seaport";
    EntityType[EntityType["Bank"] = 28] = "Bank";
    EntityType[EntityType["Bar"] = 29] = "Bar";
    EntityType[EntityType["CoffeeShop"] = 30] = "CoffeeShop";
    EntityType[EntityType["Fitness"] = 31] = "Fitness";
    EntityType[EntityType["GroceryStore"] = 32] = "GroceryStore";
    EntityType[EntityType["RailRoad"] = 36] = "RailRoad";
    EntityType[EntityType["CommuterRailRoad"] = 37] = "CommuterRailRoad";
})(EntityType || (EntityType = {}));
import { PointOfInterestDetailType } from "../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/index.js";
/** CoStar.Api.Maps.PointsOfInterest.PointOfInterestDetailType */
export { PointOfInterestDetailType };
/** CoStar.Api.Maps.PointsOfInterest.TransitPointsOfInterestMode */
export var TransitPointsOfInterestMode;
(function (TransitPointsOfInterestMode) {
    TransitPointsOfInterestMode[TransitPointsOfInterestMode["Default"] = 0] = "Default";
    TransitPointsOfInterestMode[TransitPointsOfInterestMode["Nearby"] = 1] = "Nearby";
})(TransitPointsOfInterestMode || (TransitPointsOfInterestMode = {}));
export { IntegrationTesting };
